
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fabrics/category/[slug]/page/[page]",
      function () {
        return require("private-next-pages/fabrics/category/[slug]/page/[page].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/fabrics/category/[slug]/page/[page]"])
      });
    }
  